import { c as _c } from "react/compiler-runtime";
import { useEffect, useState } from 'react';
import { flushSync } from 'react-dom';

/**
 * The day a sheet is printed on.
 *
 * Taken again when a print starts: a page left open overnight would print
 * the day it was opened. Flushed at once, because the browser lays the sheet
 * out as soon as `beforeprint` returns.
 */
export const usePrintDate = () => {
  const $ = _c(2);
  const [printDate, setPrintDate] = useState(_temp);
  let t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = () => {
      const takeToday = () => {
        flushSync(() => setPrintDate(new Date()));
      };
      window.addEventListener("beforeprint", takeToday);
      return () => {
        window.removeEventListener("beforeprint", takeToday);
      };
    };
    t1 = [];
    $[0] = t0;
    $[1] = t1;
  } else {
    t0 = $[0];
    t1 = $[1];
  }
  useEffect(t0, t1);
  return printDate;
};
function _temp() {
  return new Date();
}